import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { tid } from "@/lib/testids";

function getSessionIdFromHash(hash) {
  const cleaned = (hash || "").replace(/^#/, "");
  const params = new URLSearchParams(cleaned);
  return params.get("session_id");
}

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    const run = async () => {
      if (processed.current) return;
      processed.current = true;

      const sessionId = getSessionIdFromHash(window.location.hash);
      if (!sessionId) {
        navigate("/");
        return;
      }

      try {
        await api.get("/auth/session", { headers: { "X-Session-ID": sessionId } });
        // remove hash
        window.history.replaceState(null, "", window.location.pathname);
        await refresh();
        // Return to the page user was on before login
        const returnUrl = sessionStorage.getItem('loginReturnUrl') || '/browse';
        sessionStorage.removeItem('loginReturnUrl');
        navigate(returnUrl);
      } catch {
        navigate("/");
      }
    };
    run();
  }, [navigate, refresh]);

  return (
    <div
      data-testid={tid.authCallbackPage}
      className="mx-auto max-w-3xl px-4 py-20 text-center"
    >
      <div className="text-sm font-semibold text-slate-900">Signing you in…</div>
      <div className="mt-2 text-sm text-slate-600">One moment while we finish authentication.</div>
    </div>
  );
}
